import React from 'react';
import clsx from 'clsx';

export const getYouTubeVideoId = (url) => {
    if (!url) return null;
    const match = String(url).match(
        /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?.*v=|embed\/|v\/|shorts\/|live\/))([A-Za-z0-9_-]{11})/
    );
    return match ? match[1] : null;
};

export const youtubeEmbedSrc = (videoId, { autoplay = false } = {}) =>
    `https://www.youtube.com/embed/${videoId}?controls=1&rel=0&modestbranding=1&playsinline=1&fs=1${autoplay ? '&autoplay=1' : ''}`;

export const getYouTubeThumbnail = (videoId) =>
    videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;

const YouTubePlayer = ({ videoId, title, className, fit = 'page', autoPlay = false, onLoad }) => {
    if (!videoId) return null;

    return (
        <div
            className={clsx(
                'relative w-full overflow-hidden bg-black aspect-video',
                fit === 'page' && 'mx-auto max-h-[80vh] rounded-lg',
                fit === 'modal' && 'rounded-none',
                fit === 'card' && 'rounded-lg',
                className
            )}
            style={
                fit === 'page'
                    ? { maxWidth: 'min(100%, calc(80vh * 16 / 9))' }
                    : undefined
            }
        >
            <iframe
                src={youtubeEmbedSrc(videoId, { autoplay: autoPlay })}
                title={title}
                className="absolute inset-0 w-full h-full border-0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                allowFullScreen
                onLoad={onLoad}
            />
        </div>
    );
};

export default YouTubePlayer;
